import { Component, OnInit } from '@angular/core';
import { User } from '../../models/user'
import { UserService } from '../../services/user.service'
import { environment } from '../../../environments/environment'


@Component({
    selector: 'user-info',
    templateUrl: 'user-info.component.html',
    styleUrls: ['user-info.component.css'],
    moduleId: module.id
})

export class UserInfoComponent implements OnInit{
    user: User;
    open: boolean = false;
    loading: boolean = true;
    env: String = environment.name;
    constructor(
        private userService: UserService
    ) {}
    ngOnInit(): void {
        let me = this;

        this.userService.me().then(function(user: User){
            me.user = user;
            me.loading = false;
        })
    }
    toggleOpen(): void {
        this.open = !this.open;
    }


}



// WEBPACK FOOTER //
// ./src/app/components/user-info/user-info.component.ts